import React, { useState, useEffect } from "react";
import { Text, StyleSheet, View, Platform } from "react-native";
import AppTheme from "../../AppTheme";

export default function ActivityTags({
  activity,
  controller,
  showAll = false,
}) {
  const maxNumberToDisplay = 3;
  const [tagsList, setTagsList] = useState([]);
  const [hasMore, setHasMore] = useState(false);

  useEffect(() => {
    const allTags = activity.tagsList || [];
    const selectedTags = allTags.slice(
      0,
      showAll ? allTags.length : maxNumberToDisplay,
    );
    setTagsList(selectedTags);
    setHasMore(allTags.length > maxNumberToDisplay);
  }, [showAll, controller.state.elements]);

  return (
    <View style={[styles.listContainer, showAll && styles.listContainerAll]}>
      {tagsList.map((tag, index) => (
        <View style={styles.tagItem} key={tag.id}>
          <View
            style={[index == 0 && false ? styles.mainTagDot : styles.dot]}
          ></View>
          <Text style={styles.tagText}>{tag.name}</Text>
        </View>
      ))}
      {!showAll && hasMore ? <Text style={styles.more}>...</Text> : null}
    </View>
  );
}

const styles = StyleSheet.create({
  listContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    paddingHorizontal: 15,
    marginTop: 3,
    overflow: "hidden",
  },
  listContainerAll: {
    flexWrap: "wrap",
  },
  tagItem: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 4,
  },
  dot: {
    width: 4,
    height: 4,
    borderRadius: 2,
    backgroundColor: "#555",
  },
  mainTagDot: {
    width: 6,
    height: 6,
    borderRadius: 3,
    backgroundColor: AppTheme.DEFAULT_COLOR,
  },
  tagText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-Regular" }),
    fontWeight: "300",
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0.5,
    color: "#2D3142",
    marginLeft: 5,
  },
  more: {
    fontFamily:  Platform.select({ default: "Nunito", android: "Nunito-Regular" }),
    fontWeight: "300",
    fontSize: 12,
    color: "#555",
  },
});
